import {SP_API_URL, API_ROUTES } from '../utils/constants';
import axios from 'axios';
import  secureLocalStorage  from  "react-secure-storage";

async function request(options) {
    
    if(!options.headers){
        options.headers = {};
    }

    // allow for a token to be passed into options...
    if(!options.hasOwnProperty("token")){
      options.headers["Token"] = getToken();
    }else{
      options.headers["Token"] = `${options.token}`;
    }
        
    if(!options.method){
        options.method = "GET";
    }

    const response = await axios(options);

    return response;

}

export function getToken() {
    const queryParameters = new URLSearchParams(window.location.search)
    return secureLocalStorage.getItem('token') || queryParameters.get("token") || "";
}

export async function getUser(installSid, userSid) {
  
  try {
    const url = `${SP_API_URL}/v1/installs/${installSid}/users/${userSid}/profile`;
    
    const response = await request({
        url: url,
        token: getToken()
      });

    const result = {
        successful: response.status === 200,
        data: response.data || null
    }

    return result;
  }
  catch (err) {
    console.log(err);
    //console.log('getAuthenticatedUser, Something Went Wrong', err);
    return {successful: false};
  }
}


export async function checkAuthentication() {
  
  try {
    
    const response = await request({
        url: API_ROUTES.CHECK_AUTHENTICATION,
        token: getToken()
      });

    const result = {
        successful: response.status === 200,
        data: response.data || null
    }

    return result;
  }
  catch (err) {
    console.log(err);
    //console.log('getAuthenticatedUser, Something Went Wrong', err);
    return {successful: false};
  }
}

export async function getSession(sessionSid) {
  
  try {
    const url = `${SP_API_URL}/v1/sessions/${sessionSid}`;
    
    const response = await request({
        url: url,
        token: getToken()
      }); 

    const result = {
        successful: response.status === 200,
        data: response.data || null
    }

    return result;
  }
  catch (err) {
    console.log(err);
    //console.log('getAuthenticatedUser, Something Went Wrong', err);
    return {successful: false};
  }
}

export async function getCourse(installSid, courseSid) {
  
  try {
    const url = `${SP_API_URL}/v1/installs/${installSid}/courses/${courseSid}`;
    
    const response = await request({
        url: url,
        token: getToken()
      }); 

    const result = {
        successful: response.status === 200,
        data: response.data || null
    }

    return result;
  }
  catch (err) {
    console.log(err);
    //console.log('getAuthenticatedUser, Something Went Wrong', err);
    return {successful: false};
  }
}

export async function getExam(installSid, courseSid, examSid) {
  
  try {
    const url = `${SP_API_URL}/v1/installs/${installSid}/courses/${courseSid}/exams/${examSid}`;
    
    const response = await request({
        url: url,
        token: getToken()
      }); 

    const result = {
        successful: response.status === 200,
        data: response.data || null
    }

    return result;
  }
  catch (err) {
    console.log(err);
    //console.log('getAuthenticatedUser, Something Went Wrong', err);
    return {successful: false};
  }
}


export async function getUserTransactions(installSid, userSid, sessionSid) {
  
  try {
    const url = `${SP_API_URL}/v1/install/${installSid}/users/${userSid}/transactions`;
    
    const response = await request({
        url: url,
        token: getToken()
      }); 

    const result = {
        successful: response.status === 200,
        data: response.data || null
    }

    return result;
  }
  catch (err) {
    console.log(err);
    //console.log('getAuthenticatedUser, Something Went Wrong', err);
    return {successful: false};
  }
}

  export async function getProctorTypes() {
  
    try {
      const url = `${SP_API_URL}/v1/proctors/categories`;
      
      const response = await request({
          url: url,
          token: getToken()
        }); 
  
      const result = {
          successful: response.status === 200,
          data: response.data || null
      }
  
      return result;
    }
    catch (err) {
      console.log(err);
      //console.log('getAuthenticatedUser, Something Went Wrong', err);
      return {successful: false};
    }
}

export async function getTimezones() {
  
  try {
    const url = `${SP_API_URL}/v1/timeZones`;
    
    const response = await request({
        url: url,
        token: getToken()
      }); 

    const result = {
        successful: response.status === 200,
        data: response.data || null
    }

    return result;
  }
  catch (err) {
    console.log(err);
    //console.log('getAuthenticatedUser, Something Went Wrong', err);
    return {successful: false};
  }
}

export async function getInstall(installSid) {
  
  try {
    const url = `${SP_API_URL}/v1/installs/${installSid}/settings`;
    
    const response = await request({
        url: url,
        token: getToken()
      }); 

    const result = {
        successful: response.status === 200,
        data: response.data || null
    }

    return result;
  }
  catch (err) {
    console.log(err);
    //console.log('getAuthenticatedUser, Something Went Wrong', err);
    return {successful: false};
  }
}

